import { VSwitch } from 'vuetify/lib'
import { defaultFun } from '../utils'
import { SWITCH } from '../type_name'
import commonMixins from './commonMixins'
export default {
    name:SWITCH,
    mixins: [ commonMixins ],
    render(h) {
        const {
                         // eslint-disable-next-line 
                         slots,scopedSlots,
             key,
             change = defaultFun,
             mousedown = defaultFun,
             mouseup = defaultFun,
             ...params 
            } = this.field
        return h(VSwitch, {
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            props: {
                ...params,
                inputValue: this.my_value[key]
            },
            on: {
                blur,
                change:(data) => {
                    this.my_value[key] = data
                    change(data)
                },
                focus,
                mousedown,
                mouseup,
            }
        })
    }
}